import { environment } from 'src/environments/environment';

export abstract class SpartaxUtils {

    static openOrder(orderListItemId: number, target: '_self' | '_blank' = '_blank') {
        const spartaxBaseUrl = environment.spartaxProd ? 'https://spartax.sharepoint.com/sites/portal' : 'https://spartax.sharepoint.com/sites/portaltest';
        const spartaxListId = environment.spartaxProd ? '314363d3-bdf9-46fc-9421-ab57a1a3bfad' : 'e63ba90a-f747-44db-8c9d-038a0f9a3eda';
        window.open(`${spartaxBaseUrl}/_layouts/15/ListForm.aspx?PageType=6&ListID=${spartaxListId}&ID=${orderListItemId}`, target);
    }

    static validateSvNummer(svNummer: number): boolean {
        if (svNummer === 1234567890) {
            return true;
        }

        const svNummerStr = svNummer?.toString();
        if (svNummerStr && svNummerStr.length === 10) {
            const pruefZifferCalc = (
                (+svNummerStr.charAt(0) * 3) +
                (+svNummerStr.charAt(1) * 7) +
                (+svNummerStr.charAt(2) * 9) +
                (+svNummerStr.charAt(4) * 5) +
                (+svNummerStr.charAt(5) * 8) +
                (+svNummerStr.charAt(6) * 4) +
                (+svNummerStr.charAt(7) * 2) +
                (+svNummerStr.charAt(8) * 1) +
                (+svNummerStr.charAt(9) * 6)
            ) % 11;

            return pruefZifferCalc.toString() === svNummerStr.charAt(3);
        }

        return false;
    }
}